// extracted by mini-css-extract-plugin
export default {"h2":"zWZXfJ","h3":"PoxC4c","h4":"o8mKZp","label":"wcVdV7"};